import { MutationHookOptions, useMutation } from '@apollo/client';
import { UPDATE_CREATOR_TASKS_CONFIG } from '../queries/CreatorTasksConfig';
import { UpdateCreatorTasksConfig, UpdateCreatorTasksConfigVariables } from '../queries/types/UpdateCreatorTasksConfig';

type Options = MutationHookOptions<UpdateCreatorTasksConfig, UpdateCreatorTasksConfigVariables>;

export const useUpdateCreatorTasksConfig = (options: Options = {}) => {
  const [updateCreatorTasksConfig, { loading, error }] = useMutation(UPDATE_CREATOR_TASKS_CONFIG, options);

  return {
    updateCreatorTasksConfig,
    isUpdateCreatorTasksConfigLoading: loading,
    updateCreatorTasksConfigError: error,
  };
};
